export const EMPLOYER_PORTAL_TRANSITION_URL = 'https://www.jobcase.com/employer-onboarding?utm_source=Upward';

export const DE_SHUTDOWN_DATE_TEXT = 'July 31, 2026';

// Direct Employer section pages (the ones being shut down); used to decide
// where the transition banner shows. Segment-safe prefixes — admin pages like
// /employer/jobContent or /employer/jobCategorizationRules must NOT match.
export const DIRECT_EMPLOYER_PAGE_PATHS = [
   '/employer/job',
   '/employer/jobgroup',
   '/employer/company',
   '/employer/accountStatus',
   '/employer/jobreport',
   '/employer/candidate',
   '/employer/messages',
   '/employer/billing',
   '/employer/billingReport',
   '/employer/transactions',
   '/employer/account',
   '/employer/myAccounts',
];

export const isDirectEmployerPagePath = (pathname) => (
   DIRECT_EMPLOYER_PAGE_PATHS.some((path) => (
      pathname === path || pathname.startsWith(`${ path }/`)
   ))
);
